module.exports = __webpack_public_path__ + "static/media/accessory33.00b6d11f.webp";